import React from 'react';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import { ItemTitle } from 'app/blocks/titles/titles';
import Item from './Item';
import './article-affiliations-help-widget.scss';

export enum HelpWidgetFlowType {
    MAIN = 'MAIN',
    AUTHOR_TO_FUNDER = 'AUTHOR_TO_FUNDER',
    FUNDER_TO_AUTHOR = 'FUNDER_TO_AUTHOR',
    FUNDER_TO_AUTHOR_ACCOUNT_BALANCE_NOT_ENOUGH = 'FUNDER_TO_AUTHOR_ACCOUNT_BALANCE_NOT_ENOUGH',
    GEOGRAPHIC_DISCOUNT_OR_WAIVER_REMOVAL = 'GEOGRAPHIC_DISCOUNT_OR_WAIVER_REMOVAL',
}

interface ArticleAffiliationsHelpWidgetItem {
    title: string;
    description: string;
}

interface ArticleAffiliationsHelpWidgetFlowData {
    items: ArticleAffiliationsHelpWidgetItem[] | { [key: string]: ArticleAffiliationsHelpWidgetItem };
}

interface ArticleAffiliationsHelpWidgetCodes {
    [key: string]: {
        [key in HelpWidgetFlowType]?: ArticleAffiliationsHelpWidgetFlowData;
    };
}

type ArticleAffiliationsHelpWidgetProps = {
    codes: ArticleAffiliationsHelpWidgetCodes;
    flowType: HelpWidgetFlowType;
    l: (key: string) => string;
};

function ArticleAffiliationsHelpWidget(props: ArticleAffiliationsHelpWidgetProps) {
    const { codes, flowType, l } = props;

    const validFlowType =
        flowType && Object.values(HelpWidgetFlowType).includes(flowType as HelpWidgetFlowType)
            ? flowType
            : HelpWidgetFlowType.MAIN;

    const flowData = codes[ID.ARTICLE_AFFILIATION_HELP_WIDGET]?.[validFlowType];
    let items: ArticleAffiliationsHelpWidgetItem[] = [];

    if (flowData?.items) {
        items = Array.isArray(flowData.items) ? flowData.items : Object.values(flowData.items);
    }

    const titleKey = `${ID.ARTICLE_AFFILIATION_HELP_WIDGET}.${validFlowType}.TITLE`;

    return (
        <section className="ArticleAffiliationsHelpWidget" data-seleniumid="ArticleAffiliationsHelpWidget">
            <ItemTitle className="ArticleAffiliationsHelpWidget-Title mb-2x" component="h3">
                {l(titleKey)}
            </ItemTitle>
            {items.map((item, index) => (
                <Item key={item.title} description={item.description} index={index} title={item.title} />
            ))}
        </section>
    );
}

export default withCodes2(ID.ARTICLE_AFFILIATION_HELP_WIDGET)(ArticleAffiliationsHelpWidget);
